import { createApp, markRaw } from 'vue';
import { createPinia } from 'pinia';
import { Vue3ProgressPlugin } from '@marcoschulte/vue3-progress';
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import mitt from 'mitt';
import Vue3ApexCharts from 'vue3-apexcharts';
import 'vue3-perfect-scrollbar/style.css';
import '@marcoschulte/vue3-progress/dist/index.css';
// Imported here (JS-side), not as a CSS @import from app.css: Vite's module
// graph resolves and content-hashes the referenced .woff2 files correctly
// this way. A CSS-to-CSS @import of this package left the emitted @font-face
// url()s as unresolved relative paths (./files/...), which the SPA catch-all
// rewrite then served index.html for — the browser tried to parse HTML as a
// font, hence "OTS parsing error: invalid sfntVersion".
import '@fontsource-variable/inter';
import '@/assets/app.css'

import vuetify from './plugins/vuetify'

import App from './App.vue';
import router from './router';
import { useUiStore } from './stores/storeUi';
const emitter = mitt();
const app = createApp(App);

const pinia = createPinia()

pinia.use(({ store }) => {
  store.router = markRaw(router)
})

app.use(pinia);
app.use(router);
app.use(Vue3ProgressPlugin);
app.use(PerfectScrollbarPlugin);
app.use(vuetify);
app.use(Vue3ApexCharts);
app.config.globalProperties.emitter = emitter;

// Surface unexpected errors as a snackbar rather than a blocking native
// alert(). Pinia is active by the time these can fire (app.use(pinia) runs
// above), but the store access is guarded defensively since these are the
// last line of defence and must never themselves throw.
function notifyError(text: string) {
  try {
    useUiStore().reportError(text)
  } catch {
    console.error(text)
  }
}

app.config.errorHandler = (err, instance, info) => {
  console.error("Global Error Handler:", err, "Vue Info:", info)
  notifyError('Something went wrong. Please try again.')
}

window.onerror = function (message, source, lineno, colno, error) {
  console.error("Window Error:", message, `${source}:${lineno}:${colno}`, error)
  notifyError('Something went wrong. Please try again.')
  return false
}

window.addEventListener('unhandledrejection', event => {
  console.error("Unhandled Promise Rejection:", event.reason)
  notifyError('Something went wrong. Please try again.')
})

app.mount('#app');

